import type { TAuthResponse } from '@/fetchers/umsAPI/umsAuthenticator.fetchers';
import getConfig from 'next/config';

export const refreshToken = async (refreshToken: string): Promise<TAuthResponse> => {
  const { publicRuntimeConfig } = getConfig();
  try {
    const res = await fetch(`${publicRuntimeConfig.pmUmsUrl}/api/v1/auth/refresh/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!res.ok) {
      throw new Error('Failed to refresh token');
    }

    const { data } = await res.json();

    if (!data?.access_token) {
      throw new Error('Failed to refresh token: No access token received');
    }

    return data;
  } catch (error: any) {
    console.error('/api/v1/auth/refresh ', error);
    throw error;
  }
};
